(function () {
  "use strict";

  var GLOBAL_KEY = "SilkSilkyLoyaltyCartRedemption";
  var ROOT_SELECTOR = "[data-loyalty-cart-redemption-root]";
  var ENTRY_SELECTOR = "[data-loyalty-redemption-entry]";
  var BUTTON_SELECTOR = "[data-loyalty-redemption-button]";
  var MOUNT_SELECTOR = [ROOT_SELECTOR, ENTRY_SELECTOR, BUTTON_SELECTOR].join(
    ",",
  );
  var LOYALTY_CODE_PATTERN = /^SSLOYALTY-/i;
  var INTERNAL_CART_MUTATION_OPTION = "ssCartPromotionInternal";
  var PREVIEW_DELAY_MS = 250;

  if (window[GLOBAL_KEY] && window[GLOBAL_KEY].__theme === true) {
    window[GLOBAL_KEY].initialize();
    return;
  }

  var started = false;
  var boundDocument = null;
  var observedDocument = null;
  var observer = null;
  var previewTimer = 0;
  var refreshTimer = 0;

  var state = {
    config: null,
    labels: defaultLabels(),
    bootstrap: null,
    activeRedemption: null,
    cart: null,
    loaded: false,
    loading: false,
    mutation: "",
    previewing: false,
    error: "",
    actionError: "",
    draftError: "",
    draftPoints: 0,
    draftPreview: null,
    previewSignature: "",
    previewPromise: null,
    previewAbortController: null,
    refreshPromise: null,
    refreshRequested: false,
    operationId: "",
    currencyCode: "USD",
    moneyFormat: "",
    cartTotalCents: 0,
    cartDiscountCodes: [],
    cartLoyaltyDiscountCents: 0,
    cartSnapshotRevision: 0,
  };

  window[GLOBAL_KEY] = {
    __theme: true,
    initialize: initialize,
    refresh: refresh,
    removeDiscountCode: removeDiscountCode,
    syncCartSnapshot: syncCartSnapshot,
  };

  start();

  function start() {
    if (started) return;
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", start, { once: true });
      return;
    }
    started = true;
    bindGlobalEvents();
    observeDom();
    initialize();
  }

  function initialize() {
    bindGlobalEvents();
    observeDom();
    var roots = getRoots();
    if (!roots.length) return;
    roots.forEach(bindRoot);
    readRuntimeConfig(roots[0]);
    renderAll();
    if (!state.loaded && !state.refreshPromise) {
      void refresh({ force: true });
    }
  }

  function bindGlobalEvents() {
    if (boundDocument === document) return;
    boundDocument = document;
    document.addEventListener("click", handleDocumentClick, true);
    document.addEventListener("change", handleDocumentChange);
    [
      "cart:updated",
      "cart:refresh",
      "ajaxCart:updated",
      "theme:cart:change",
      "shopify:section:load",
    ].forEach(function (eventName) {
      document.addEventListener(eventName, scheduleRefresh);
    });
    document.addEventListener("ss:cart:promotion:refresh", scheduleRefresh);
    window.addEventListener("pageshow", function () {
      scheduleRefresh();
    });
  }

  function observeDom() {
    if (
      observedDocument === document ||
      typeof MutationObserver !== "function"
    ) {
      return;
    }
    observedDocument = document;
    observer = new MutationObserver(function (records) {
      var hasNewMount = Array.prototype.some.call(
        records || [],
        function (record) {
          return Array.prototype.some.call(
            record.addedNodes || [],
            containsLoyaltyMount,
          );
        },
      );
      if (hasNewMount) initialize();
    });
    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
    });
  }

  function containsLoyaltyMount(node) {
    if (!node || (node.nodeType !== 1 && node.nodeType !== 11)) return false;
    if (node.matches && node.matches(MOUNT_SELECTOR)) return true;
    return Boolean(node.querySelector && node.querySelector(MOUNT_SELECTOR));
  }

  function bindRoot(root) {
    var input = root.querySelector("[data-loyalty-redemption-points-input]");
    if (input && input.dataset.loyaltyRedemptionBound !== "true") {
      input.dataset.loyaltyRedemptionBound = "true";
      input.addEventListener("input", function () {
        updateDraftPoints(input.value, PREVIEW_DELAY_MS);
      });
      input.addEventListener("change", function () {
        updateDraftPoints(input.value, 0);
      });
    }
    var range = root.querySelector("[data-loyalty-redemption-range]");
    if (range && range.dataset.loyaltyRedemptionBound !== "true") {
      range.dataset.loyaltyRedemptionBound = "true";
      range.addEventListener("input", function () {
        updateDraftPoints(range.value, PREVIEW_DELAY_MS);
      });
      range.addEventListener("change", function () {
        updateDraftPoints(range.value, 0);
      });
    }
  }

  function handleDocumentClick(event) {
    var target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    var entryButton = target.closest(BUTTON_SELECTOR);
    if (entryButton) {
      event.preventDefault();
      event.stopPropagation();
      if (isPanelOpen(entryButton)) {
        closePanel();
      } else {
        openPanel(entryButton);
        void refresh({ force: true });
      }
      return;
    }
    var applyButton = target.closest("[data-loyalty-redemption-apply]");
    if (applyButton) {
      event.preventDefault();
      event.stopPropagation();
      void applyDraftSelection(applyButton);
      return;
    }
    var removeButton = target.closest("[data-loyalty-redemption-remove]");
    if (removeButton) {
      event.preventDefault();
      event.stopPropagation();
      void removeActiveRedemption(removeButton);
      return;
    }
    var cancelButton = target.closest("[data-loyalty-redemption-cancel]");
    if (cancelButton) {
      event.preventDefault();
      event.stopPropagation();
      closePanel();
      return;
    }
    var otherAddonButton = target.closest("[data-open]");
    if (otherAddonButton && !otherAddonButton.matches(BUTTON_SELECTOR)) {
      closePanel();
    }
  }

  function handleDocumentChange(event) {
    if (
      event.target &&
      event.target.matches &&
      event.target.matches("[data-cart-quantity-input]")
    ) {
      scheduleRefresh();
    }
  }

  function scheduleRefresh(event) {
    if (
      event &&
      event.type === "ss:cart:promotion:refresh" &&
      event.detail &&
      event.detail.source &&
      event.detail.refreshLoyalty !== true
    ) {
      return;
    }
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      void refresh({ force: true });
    }, 120);
  }

  async function refresh(options) {
    if (!state.config) {
      var roots = getRoots();
      if (!roots.length) return null;
      readRuntimeConfig(roots[0]);
    }
    state.refreshRequested = true;
    if (state.refreshPromise) return state.refreshPromise;
    var hasData = state.loaded;
    state.loading = !hasData;
    if (!hasData) state.error = "";
    renderAll();

    state.refreshPromise = (async function () {
      var latestBootstrap = null;
      do {
        state.refreshRequested = false;
        try {
          var cartRevision = state.cartSnapshotRevision;
          var cart = await readCart();
          if (state.cartSnapshotRevision === cartRevision) {
            syncCart(cart);
          } else {
            cart = state.cart || cart;
          }
          var bootstrap = await loadBootstrap(options);
          if (!bootstrap) throw new Error(state.labels.unavailable);
          state.bootstrap = bootstrap;
          state.activeRedemption = normalizeActiveRedemption(
            bootstrap.activeRedemption,
          );
          var currentCart = state.cart || cart;
          state.loaded = true;
          state.error = blockingBootstrapError(bootstrap);
          if (
            !state.activeRedemption &&
            (state.actionError === state.labels.detached ||
              state.actionError === state.labels.discountConflict)
          ) {
            state.actionError = "";
          }
          if (!state.activeRedemption && !state.error) {
            ensureDraft(canRedeem());
          }
          if (
            state.activeRedemption &&
            !cartHasApplicableCode(
              currentCart,
              state.activeRedemption.discountCode,
            ) &&
            !state.actionError
          ) {
            state.actionError = state.labels.detached;
          }
          if (
            state.activeRedemption &&
            cartHasApplicableCode(
              currentCart,
              state.activeRedemption.discountCode,
            ) &&
            state.actionError === state.labels.detached
          ) {
            state.actionError = "";
          }
          latestBootstrap = bootstrap;
        } catch (error) {
          if (!state.loaded) state.error = errorMessage(error);
          latestBootstrap = null;
        }
      } while (state.refreshRequested);
      return latestBootstrap;
    })().finally(function () {
      state.loading = false;
      state.refreshPromise = null;
      renderAll();
    });
    return state.refreshPromise;
  }

  async function loadBootstrap() {
    var params = new URLSearchParams({ currencyCode: state.currencyCode });
    if (state.cartDiscountCodes.length) {
      params.set("discountCodes", state.cartDiscountCodes.join(","));
    }
    return apiFetch("/loyalty/cart-summary?" + params.toString());
  }

  async function previewDraft() {
    var limits = canRedeem();
    var points = normalizePoints(state.draftPoints, limits);
    if (!limits.canRedeem || points <= 0 || state.activeRedemption) return null;
    var signature = previewRequestSignature(points);
    if (state.draftPreview && state.previewSignature === signature) {
      return state.draftPreview;
    }
    if (state.previewPromise && state.previewSignature === signature) {
      return state.previewPromise;
    }
    if (state.previewAbortController) state.previewAbortController.abort();
    var controller =
      typeof AbortController === "function" ? new AbortController() : null;
    state.previewAbortController = controller;
    state.previewSignature = signature;
    state.previewing = true;
    state.draftError = "";
    renderAll();

    state.previewPromise = (async function () {
      try {
        var payload = await apiFetch("/loyalty/redemptions/preview", {
          method: "POST",
          signal: controller ? controller.signal : undefined,
          body: JSON.stringify({
            points: points,
            currencyCode: state.currencyCode,
            orderAmount: state.cartTotalCents / 100,
          }),
        });
        if (!payload || payload.ok === false || firstError(payload)) {
          throw new Error(firstError(payload) || state.labels.unavailable);
        }
        if (signature !== previewRequestSignature(state.draftPoints))
          return null;
        state.draftPreview = normalizePreview(payload);
        if (!state.draftPreview) throw new Error(state.labels.unavailable);
        return state.draftPreview;
      } catch (error) {
        if (error && error.name === "AbortError") return null;
        if (signature === previewRequestSignature(state.draftPoints)) {
          state.draftPreview = null;
          state.draftError = errorMessage(error);
        }
        return null;
      } finally {
        if (state.previewSignature === signature) {
          state.previewing = false;
          state.previewPromise = null;
          state.previewAbortController = null;
        }
        renderAll();
      }
    })();
    return state.previewPromise;
  }

  async function applyDraftSelection(button) {
    if (state.mutation || state.activeRedemption) return false;
    var limits = canRedeem();
    state.draftPoints = normalizePoints(state.draftPoints, limits);
    if (!limits.canRedeem || state.draftPoints <= 0) {
      state.draftError = unavailableMessage(limits);
      renderAll();
      return false;
    }
    var preview = await previewDraft();
    if (!preview || state.draftError) return false;

    state.mutation = "apply";
    state.actionError = "";
    setButtonBusy(button, true);
    renderAll();
    var createdRedemption = null;
    var createResponseReceived = false;
    try {
      var created = await apiFetch("/loyalty/redemptions", {
        method: "POST",
        body: JSON.stringify({
          points: preview.pointsToSpend,
          currencyCode: preview.currencyCode,
          orderAmount: state.cartTotalCents / 100,
          redemptionQuote: preview.redemptionQuote,
          externalEventId: getOperationId(),
          metadata: { origin: "cart" },
        }),
      });
      createResponseReceived = true;
      if (!created || created.ok === false || firstError(created)) {
        throw new Error(firstError(created) || state.labels.checkoutError);
      }
      createdRedemption = normalizeActiveRedemption(created.loyaltyRedemption);
      if (!createdRedemption) throw new Error(state.labels.checkoutError);
      state.activeRedemption = createdRedemption;
      state.operationId = "";
      renderAll();

      var result = await addLoyaltyDiscountCode(createdRedemption.discountCode);
      syncCart(result.cart);
      updateCartUI(result.cart);
      if (result.conflict) {
        state.actionError = state.labels.discountConflict;
        revealRedemptionError();
        return false;
      }
      state.actionError = "";
      closePanel();
      notifyCartChanged("loyalty-redemption-applied");
      return true;
    } catch (error) {
      if (
        createResponseReceived ||
        (error && error.name === "LoyaltyRequestCompletedError")
      ) {
        state.operationId = "";
      }
      await refresh({ force: true });
      if (state.activeRedemption) state.operationId = "";
      if (createdRedemption && !state.activeRedemption) {
        state.activeRedemption = createdRedemption;
      }
      state.actionError = errorMessage(error) || state.labels.checkoutError;
      renderAll();
      revealRedemptionError();
      return false;
    } finally {
      if (state.mutation === "apply") state.mutation = "";
      setButtonBusy(button, false);
      renderAll();
    }
  }

  async function removeActiveRedemption(button) {
    if (state.mutation || !state.activeRedemption) return false;
    var redemption = Object.assign({}, state.activeRedemption);
    state.mutation = "remove";
    state.actionError = "";
    setButtonBusy(button, true);
    renderAll();
    try {
      var result = await removeLoyaltyDiscountCode(redemption.discountCode);
      syncCart(result.cart);
      updateCartUI(result.cart);

      var canceled = await apiFetch(
        "/loyalty/redemptions/" + encodeURIComponent(redemption.id) + "/cancel",
        { method: "POST", body: "{}" },
      );
      if (!canceled || canceled.ok === false || firstError(canceled)) {
        throw new Error(firstError(canceled) || state.labels.removeError);
      }

      state.activeRedemption = null;
      state.bootstrap = Object.assign({}, state.bootstrap, {
        activeRedemption: null,
      });
      state.actionError = "";
      state.draftPreview = null;
      state.previewSignature = "";
      await refresh({ force: true });
      ensureDraft(canRedeem());
      notifyCartChanged("loyalty-redemption-removed");
      return true;
    } catch (error) {
      state.activeRedemption = redemption;
      state.actionError = errorMessage(error) || state.labels.removeError;
      renderAll();
      revealRedemptionError();
      return false;
    } finally {
      if (state.mutation === "remove") state.mutation = "";
      setButtonBusy(button, false);
      renderAll();
    }
  }

  async function removeDiscountCode(code, button) {
    if (
      !state.activeRedemption ||
      !sameCode(state.activeRedemption.discountCode, code)
    ) {
      await refresh({ force: true });
    }
    if (
      !state.activeRedemption ||
      !sameCode(state.activeRedemption.discountCode, code)
    ) {
      state.actionError = state.labels.removeError;
      renderAll();
      return false;
    }
    return removeActiveRedemption(button);
  }

  function addLoyaltyDiscountCode(code) {
    return mutateDiscountCodes(
      "loyalty-discount-apply",
      async function (existing) {
        var nonLoyaltyCodes = existing.filter(function (existingCode) {
          return !isLoyaltyCode(existingCode);
        });
        var nextCodes = uniqueStrings(nonLoyaltyCodes.concat([code]));
        var cart = await updateCartDiscountCodes(nextCodes);
        var loyaltyApplied = cartHasApplicableCode(cart, code);
        var existingPreserved = nonLoyaltyCodes.every(function (existingCode) {
          return cartHasApplicableCode(cart, existingCode);
        });
        if (loyaltyApplied && existingPreserved) {
          return { cart: cart, conflict: false };
        }
        var rollbackCart = await updateCartDiscountCodes(existing);
        return { cart: rollbackCart, conflict: true };
      },
    );
  }

  function removeLoyaltyDiscountCode(code) {
    return mutateDiscountCodes(
      "loyalty-discount-remove",
      async function (existing) {
        var nextCodes = existing.filter(function (existingCode) {
          return !sameCode(existingCode, code);
        });
        var cart = await updateCartDiscountCodes(nextCodes);
        var loyaltyRemoved = !cartHasDiscountCode(cart, code);
        var existingPreserved = nextCodes.every(function (existingCode) {
          return cartHasApplicableCode(cart, existingCode);
        });
        if (loyaltyRemoved && existingPreserved) {
          return { cart: cart, conflict: false };
        }
        await updateCartDiscountCodes(existing);
        throw new Error(state.labels.removeError);
      },
    );
  }

  function mutateDiscountCodes(name, mutation) {
    var task = async function () {
      var cart = await readCart();
      var existing = applicableDiscountCodes(cart);
      return mutation(existing);
    };
    var coordinator = window.SilkSilkyCartCoordinator;
    if (coordinator && typeof coordinator.enqueueMutation === "function") {
      return coordinator.enqueueMutation(name, task);
    }
    return task();
  }

  async function updateCartDiscountCodes(codes) {
    var response = await fetch(storefrontPath("cart/update.js"), {
      method: "POST",
      credentials: "same-origin",
      [INTERNAL_CART_MUTATION_OPTION]: true,
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({
        discount: uniqueStrings(codes).join(","),
        sections: ["minicart-form"],
        sections_url: window.location.pathname,
      }),
    });
    if (!response.ok) throw new Error(state.labels.checkoutError);
    var cart = await response.json();
    if (!cart || !Array.isArray(cart.discount_codes)) {
      throw new Error(state.labels.checkoutError);
    }
    return cart;
  }

  async function readCart() {
    var response = await fetch(storefrontPath("cart.js"), {
      credentials: "same-origin",
      headers: { Accept: "application/json" },
    });
    if (!response.ok) throw new Error(state.labels.checkoutError);
    var cart = await response.json();
    if (!cart || !Array.isArray(cart.discount_codes)) {
      throw new Error(state.labels.checkoutError);
    }
    return cart;
  }

  function syncCart(cart) {
    state.cart = cart;
    state.cartSnapshotRevision += 1;
    state.cartTotalCents = Math.max(0, readInteger(cart.total_price));
    state.currencyCode =
      normalizeCurrencyCode(cart.currency) || state.currencyCode || "USD";
    state.cartDiscountCodes = applicableDiscountCodes(cart);
    state.cartLoyaltyDiscountCents = loyaltyDiscountCents(
      cart,
      state.activeRedemption && state.activeRedemption.discountCode,
    );
  }

  function syncCartSnapshot(cart) {
    if (
      !cart ||
      !Array.isArray(cart.items) ||
      !Array.isArray(cart.discount_codes)
    ) {
      return false;
    }
    syncCart(cart);
    renderAll();
    return true;
  }

  function applicableDiscountCodes(cart) {
    var codes = [];
    if (cart && Array.isArray(cart.discount_codes)) {
      cart.discount_codes.forEach(function (discount) {
        if (discount && discount.code && discount.applicable !== false) {
          codes.push(discount.code);
        }
      });
    }
    if (cart && Array.isArray(cart.cart_level_discount_applications)) {
      cart.cart_level_discount_applications.forEach(function (application) {
        if (application && application.type === "discount_code") {
          codes.push(application.title || application.code || "");
        }
      });
    }
    return uniqueStrings(codes);
  }

  function cartHasApplicableCode(cart, code) {
    return applicableDiscountCodes(cart).some(function (candidate) {
      return sameCode(candidate, code);
    });
  }

  function cartHasDiscountCode(cart, code) {
    return Boolean(
      cart &&
      Array.isArray(cart.discount_codes) &&
      cart.discount_codes.some(function (discount) {
        return discount && sameCode(discount.code, code);
      }),
    );
  }

  function loyaltyDiscountCents(cart, expectedCode) {
    var amount = 0;
    function matches(application) {
      if (!application) return false;
      var code = application.title || application.code || "";
      return expectedCode ? sameCode(code, expectedCode) : isLoyaltyCode(code);
    }
    (cart.cart_level_discount_applications || []).forEach(
      function (application) {
        if (matches(application)) {
          amount += Math.max(
            0,
            readInteger(application.total_allocated_amount),
          );
        }
      },
    );
    if (amount > 0) return amount;
    (cart.items || []).forEach(function (item) {
      (item.line_level_discount_allocations || []).forEach(
        function (allocation) {
          if (matches(allocation.discount_application)) {
            amount += Math.max(0, readInteger(allocation.amount));
          }
        },
      );
    });
    return amount;
  }

  function updateCartUI(cart) {
    var cartElement =
      document.querySelector("cart-notification") ||
      document.querySelector("cart-drawer");
    if (cartElement && typeof cartElement.renderContents === "function") {
      cartElement.renderContents(cart, { refreshLoyalty: false });
    }
    var headerTotal = document.querySelector("header-total-price");
    if (headerTotal && typeof headerTotal.updateTotal === "function") {
      headerTotal.updateTotal(cart);
    }
  }

  function apiFetch(path, options) {
    if (!state.config) throw new Error(state.labels.unavailable);
    var requestOptions = Object.assign(
      {
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
      options || {},
    );
    return fetch(state.config.proxyPath + path, requestOptions).then(
      async function (response) {
        var payload = await response.json().catch(function () {
          return {};
        });
        if (!response.ok) {
          var error = new Error(
            firstError(payload) || state.labels.unavailable,
          );
          error.name = "LoyaltyRequestCompletedError";
          throw error;
        }
        return payload;
      },
    );
  }

  function renderAll() {
    document.querySelectorAll(ENTRY_SELECTOR).forEach(renderEntry);
    document.querySelectorAll(BUTTON_SELECTOR).forEach(renderButton);
    getRoots().forEach(renderPanel);
  }

  function renderEntry(entry) {
    var visible =
      state.loaded && (isProgramActive() || Boolean(state.activeRedemption));
    entry.hidden = !visible;
    var addons = entry.closest && entry.closest(".cart-addons");
    if (!addons || !addons.classList) return;
    addons.classList.toggle("cart-addons--with-rewards", visible);
    var count = Array.prototype.filter.call(
      addons.children || [],
      function (addon) {
        return (
          !addon.hidden &&
          !(addon.classList && addon.classList.contains("hidden"))
        );
      },
    ).length;
    addons.classList.toggle(
      "cart-addons--featured-rewards",
      visible && count === 3,
    );
  }

  function renderButton(button) {
    var label = state.labels.usePoints;
    var html = "";
    if (state.activeRedemption) {
      label = "-" + formatMoney(activeCreditCents(state.activeRedemption));
      html =
        '<span class="mini_cart_addon_label__points">' +
        escapeHtml(label) +
        "</span>";
    } else if (state.loaded && isAuthenticated()) {
      var points = formatNumber(availablePoints());
      label = interpolate(state.labels.usePointsTemplate, { points: points });
      html = interpolate(state.labels.usePointsTemplate, {
        points:
          '<span class="mini_cart_addon_label__points">' +
          escapeHtml(points) +
          "</span>",
      });
    }
    var labelElement = button.querySelector(
      "[data-loyalty-redemption-button-label]",
    );
    if (labelElement) {
      if (html) labelElement.innerHTML = html;
      else labelElement.textContent = label;
    }
    button.setAttribute("aria-label", label);
  }

  function renderPanel(root) {
    var limits = canRedeem();
    var active = state.activeRedemption;
    var status = root.querySelector("[data-loyalty-redemption-status]");
    var form = root.querySelector("[data-loyalty-redemption-form]");
    var available = root.querySelector("[data-loyalty-redemption-available]");
    var message = root.querySelector("[data-loyalty-redemption-message]");
    var applyButton = root.querySelector("[data-loyalty-redemption-apply]");
    var removeButton = root.querySelector("[data-loyalty-redemption-remove]");
    var showForm = Boolean(active) || limits.canRedeem;
    var statusText = "";
    if (!showForm) {
      if (state.loading && !state.loaded) statusText = state.labels.loading;
      else statusText = state.error || unavailableMessage(limits);
    }
    if (status) {
      status.hidden = showForm;
      status.textContent = statusText;
      status.setAttribute(
        "data-tone",
        statusText && !state.loading ? "error" : "",
      );
    }
    if (form) form.hidden = !showForm;
    root.classList.toggle("is-applied", Boolean(active));
    if (showForm) {
      if (!active) ensureDraft(limits);
      var preview = active
        ? activePreview(active)
        : state.draftPreview || localPreview(state.draftPoints);
      if (available) {
        available.textContent =
          formatNumber(availablePoints()) + " " + state.labels.available;
      }
      updateDraftControls(root, limits, preview, Boolean(active));
    }
    if (applyButton) {
      applyButton.hidden = Boolean(active);
      applyButton.disabled = Boolean(
        active ||
        !showForm ||
        state.mutation ||
        state.previewing ||
        !limits.canRedeem ||
        state.draftPoints < limits.firstValid ||
        state.draftError ||
        !state.draftPreview,
      );
      applyButton.textContent =
        state.mutation === "apply" || state.previewing
          ? state.labels.applying
          : state.labels.apply;
    }
    if (removeButton) {
      removeButton.hidden = !active;
      removeButton.disabled = !active || Boolean(state.mutation);
      removeButton.textContent =
        state.mutation === "apply"
          ? state.labels.applying
          : state.mutation === "remove"
            ? state.labels.removing
            : state.labels.remove;
    }
    if (message) {
      var error = state.actionError || state.draftError || state.error;
      message.textContent =
        error ||
        (active
          ? interpolate(state.labels.redeemed, {
              points: formatNumber(active.points),
              amount: formatMoney(activeCreditCents(active)),
            })
          : showForm
            ? state.labels.applyHint
            : "");
      message.setAttribute("data-tone", error ? "error" : "");
      message.setAttribute("role", error ? "alert" : "status");
    }
  }

  function updateDraftControls(root, limits, preview, disabled) {
    var input = root.querySelector("[data-loyalty-redemption-points-input]");
    var range = root.querySelector("[data-loyalty-redemption-range]");
    [input, range].forEach(function (control) {
      if (!control) return;
      control.min = String(control === range ? 0 : limits.firstValid || 0);
      control.max = String(
        Math.max(limits.maxPoints || 0, limits.firstValid || 0),
      );
      control.step = String(limits.increment || 1);
      control.value = String(
        disabled && state.activeRedemption
          ? state.activeRedemption.points
          : state.draftPoints,
      );
      control.disabled =
        disabled || !limits.canRedeem || Boolean(state.mutation);
      if (control === range) {
        control.hidden = disabled;
        setRangeProgress(control);
      }
    });
    var pointsValue = root.querySelector(
      '[data-loyalty-redemption-preview="points"]',
    );
    var creditValue = root.querySelector(
      '[data-loyalty-redemption-preview="credit"]',
    );
    if (pointsValue)
      pointsValue.textContent = formatNumber(preview.pointsToSpend || 0);
    if (creditValue)
      creditValue.textContent = formatMoney(preview.creditCents || 0);
  }

  function setRangeProgress(range) {
    var min = Number(range.min || 0);
    var max = Number(range.max || 0);
    var value = Number(range.value || 0);
    var progress = max > min ? ((value - min) / (max - min)) * 100 : 0;
    range.style.setProperty(
      "--loyalty-redemption-range-progress",
      Math.max(0, Math.min(100, progress)) + "%",
    );
  }

  function updateDraftPoints(value, delay) {
    if (state.activeRedemption || state.mutation) return;
    var limits = canRedeem();
    state.draftPoints = normalizePoints(value, limits);
    state.draftPreview = localPreview(state.draftPoints);
    state.previewSignature = "";
    state.draftError = "";
    renderAll();
    window.clearTimeout(previewTimer);
    previewTimer = window.setTimeout(
      function () {
        void previewDraft();
      },
      Math.max(0, Number(delay) || 0),
    );
  }

  function ensureDraft(limits) {
    if (!limits.canRedeem || state.activeRedemption) return;
    if (
      (state.draftPoints <= 0 && !state.draftPreview) ||
      state.draftPoints > limits.maxPoints
    ) {
      state.draftPoints = limits.firstValid;
      state.draftPreview = localPreview(state.draftPoints);
      state.previewSignature = "";
    }
    var needsServerPreview =
      !state.draftPreview || !state.draftPreview.redemptionQuote;
    if (
      needsServerPreview &&
      !state.draftError &&
      !state.previewing &&
      !state.previewPromise
    ) {
      void previewDraft();
    }
  }

  function canRedeem() {
    var summary = state.bootstrap && state.bootstrap.summary;
    var policy =
      (summary && summary.redemptionPolicy) ||
      (state.bootstrap && state.bootstrap.redemptionPolicy) ||
      {};
    var increment = Math.max(1, readInteger(policy.redeemIncrementPoints) || 1);
    var rate = Math.max(0, Number(policy.redeemRate || 0));
    var available = availablePoints();
    var ratio =
      Math.max(0, Number(policy.maxRedemptionOrderDiscountBps || 0)) / 10000;
    var minimumCreditAmount =
      rate > 0 ? roundCurrencyAmount(increment / rate) : 0;
    var minimumOrderAmount =
      ratio > 0 ? roundCurrencyAmount(minimumCreditAmount / ratio) : 0;
    var minimumOrderCents = Math.max(
      0,
      Math.round(minimumOrderAmount * 100),
    );
    var cartGapCents = Math.max(
      0,
      minimumOrderCents - state.cartTotalCents,
    );
    var maxByCart =
      rate > 0 && ratio > 0
        ? floorToIncrement(
            Math.floor((state.cartTotalCents / 100) * ratio * rate),
            increment,
          )
        : 0;
    var configured = readInteger(policy.maxRedemptionPoints);
    var maxPoints = floorToIncrement(
      Math.min(
        available,
        maxByCart,
        configured > 0 ? configured : Number.MAX_SAFE_INTEGER,
      ),
      increment,
    );
    return {
      canRedeem: Boolean(
        state.loaded &&
        isProgramActive() &&
        isAuthenticated() &&
        summary &&
        !state.error &&
        rate > 0 &&
        maxPoints >= increment,
      ),
      increment: increment,
      firstValid: maxPoints >= increment ? increment : 0,
      maxPoints: maxPoints,
      rate: rate,
      available: available,
      minimumOrderCents: minimumOrderCents,
      cartGapCents: cartGapCents,
    };
  }

  function unavailableMessage(limits) {
    if (!isAuthenticated()) return state.labels.signIn;
    if (state.error) return state.error;
    if (!limits.available) return state.labels.noPoints;
    if (limits.cartGapCents > 0) {
      return state.labels.cartTooLow.replace(
        "{{ amount }}",
        formatMoney(limits.cartGapCents),
      );
    }
    return state.labels.unavailable;
  }

  function normalizePoints(value, limits) {
    var number = Math.max(0, Math.floor(Number(value) || 0));
    if (!limits || !limits.increment) return number;
    return Math.min(
      limits.maxPoints,
      floorToIncrement(number, limits.increment),
    );
  }

  function localPreview(points) {
    var limits = canRedeem();
    var amount = limits.rate > 0 ? Number(points || 0) / limits.rate : 0;
    return {
      pointsToSpend: Math.max(0, readInteger(points)),
      creditAmount: amount,
      creditCents: Math.max(0, Math.round(amount * 100)),
      currencyCode: state.currencyCode,
      redemptionQuote: "",
    };
  }

  function normalizePreview(payload) {
    var points = readInteger(payload.pointsToSpend);
    var amount = Number(payload.discountAmount || payload.creditAmount || 0);
    var quote = String(payload.redemptionQuote || "").trim();
    if (points <= 0 || amount <= 0 || !quote) return null;
    return {
      pointsToSpend: points,
      creditAmount: amount,
      creditCents: Math.round(amount * 100),
      currencyCode:
        normalizeCurrencyCode(payload.currencyCode) || state.currencyCode,
      redemptionQuote: quote,
    };
  }

  function normalizeActiveRedemption(redemption) {
    if (!redemption) return null;
    var id = String(redemption.id || "").trim();
    var code = String(redemption.discountCode || "").trim();
    var points = readInteger(redemption.pointsSpent || redemption.points);
    var amount = Number(
      redemption.discountAmount || redemption.creditAmount || 0,
    );
    if (!id || !isLoyaltyCode(code) || points <= 0 || amount <= 0) return null;
    return {
      id: id,
      discountCode: code,
      points: points,
      creditAmount: amount,
      creditCents: Math.round(amount * 100),
      currencyCode:
        normalizeCurrencyCode(redemption.currencyCode) || state.currencyCode,
    };
  }

  function activePreview(redemption) {
    return {
      pointsToSpend: redemption.points,
      creditAmount: activeCreditCents(redemption) / 100,
      creditCents: activeCreditCents(redemption),
      currencyCode: redemption.currencyCode,
    };
  }

  function activeCreditCents(redemption) {
    return state.cartLoyaltyDiscountCents > 0
      ? state.cartLoyaltyDiscountCents
      : Math.max(0, readInteger(redemption && redemption.creditCents));
  }

  function availablePoints() {
    return Math.max(
      0,
      readInteger(
        state.bootstrap &&
          state.bootstrap.summary &&
          state.bootstrap.summary.availablePoints,
      ),
    );
  }

  function previewRequestSignature(points) {
    return [readInteger(points), state.currencyCode, state.cartTotalCents].join(
      ":",
    );
  }

  function blockingBootstrapError(payload) {
    if (!payload) return state.labels.unavailable;
    if (payload.ok === false)
      return firstError(payload) || state.labels.unavailable;
    return "";
  }

  function isProgramActive() {
    return Boolean(
      state.bootstrap &&
      state.bootstrap.program &&
      state.bootstrap.program.isActive !== false,
    );
  }

  function isAuthenticated() {
    return Boolean(
      state.config &&
      state.config.customerId &&
      state.bootstrap &&
      state.bootstrap.authenticated,
    );
  }

  function getOperationId() {
    if (!state.operationId) {
      var id =
        window.crypto && typeof window.crypto.randomUUID === "function"
          ? window.crypto.randomUUID()
          : Date.now() + "-" + Math.random().toString(36).slice(2);
      state.operationId = "cart-rewards:" + id;
    }
    return state.operationId;
  }

  function readRuntimeConfig(root) {
    state.config = {
      proxyPath: normalizePath(root.dataset.proxyPath),
      customerId: String(root.dataset.customerId || ""),
      shopDomain: String(root.dataset.shopDomain || ""),
    };
    state.labels = readLabels(root);
    state.currencyCode =
      normalizeCurrencyCode(root.dataset.currencyCode) ||
      normalizeCurrencyCode(
        window.Shopify &&
          window.Shopify.currency &&
          window.Shopify.currency.active,
      ) ||
      "USD";
    state.moneyFormat = root.dataset.moneyFormat || "";
    if (!state.cart) {
      state.cartTotalCents = Math.max(
        0,
        readInteger(root.dataset.cartTotalCents),
      );
    }
  }

  function readLabels(root) {
    var data = root ? root.dataset : {};
    return decodeLabels({
      points: data.labelPoints || "Points",
      usePoints: data.labelUsePoints || "Use points",
      usePointsTemplate:
        data.labelUsePointsTemplate || "Use your points: {{ points }}",
      signIn: data.labelSignIn || "Sign in",
      loading: data.labelLoading || "Loading...",
      unavailable: data.labelUnavailable || "Unavailable",
      noPoints: data.labelNoPoints || "No points",
      cartTooLow: data.labelCartTooLow || "Add more items to redeem points",
      available: data.labelAvailable || "available",
      apply: data.labelApply || "Apply",
      remove: data.labelRemove || "Remove",
      applying: data.labelApplying || "Applying...",
      removing: data.labelRemoving || "Removing...",
      redeemed:
        data.labelRedeemed ||
        "{{ points }} points redeemed for {{ amount }} off.",
      checkoutError: data.labelCheckoutError || "Unable to apply points.",
      discountConflict:
        data.labelDiscountConflict ||
        "Points can't be combined with your existing discount. Remove the other discount and try again.",
      removeError: data.labelRemoveError || "Unable to remove redeemed points.",
      applyHint:
        data.labelApplyHint ||
        "Your points discount will be applied to this cart immediately.",
      detached:
        data.labelDetached ||
        "Your points are reserved but the discount is not applied. Remove it to return your points.",
    });
  }

  function defaultLabels() {
    return readLabels(null);
  }

  function decodeLabels(labels) {
    Object.keys(labels).forEach(function (key) {
      var textarea = document.createElement("textarea");
      textarea.innerHTML = labels[key];
      labels[key] = textarea.value;
    });
    return labels;
  }

  function getRoots() {
    return Array.prototype.slice.call(document.querySelectorAll(ROOT_SELECTOR));
  }

  function getPanel(button) {
    var wrapper = button && button.closest(".minicart__wrapper");
    return (
      (wrapper && wrapper.querySelector("#loyalty-redemption")) ||
      document.getElementById("loyalty-redemption")
    );
  }

  function isPanelOpen(button) {
    var panel = getPanel(button);
    return Boolean(panel && panel.classList.contains("is-open"));
  }

  function openPanel(button) {
    closePanel();
    closeOtherAddonPanels(button);
    var panel = getPanel(button);
    if (panel) panel.classList.add("is-open");
    if (button) {
      button.classList.add("open");
      button.setAttribute("aria-expanded", "true");
    }
  }

  function closeOtherAddonPanels(button) {
    var wrapper = button && button.closest(".minicart__wrapper");
    if (!wrapper) return;
    wrapper
      .querySelectorAll(".cart__addon-content.is-open")
      .forEach(function (panel) {
        panel.classList.remove("is-open");
      });
    wrapper
      .querySelectorAll(".mini_cart_addon_btn.open")
      .forEach(function (addonButton) {
        addonButton.classList.remove("open");
      });
  }

  function closePanel() {
    document
      .querySelectorAll(".loyalty-cart-redemption-panel.is-open")
      .forEach(function (panel) {
        panel.classList.remove("is-open");
      });
    document.querySelectorAll(BUTTON_SELECTOR).forEach(function (button) {
      button.classList.remove("open");
      button.setAttribute("aria-expanded", "false");
    });
  }

  function revealRedemptionError() {
    var button = document.querySelector(BUTTON_SELECTOR);
    if (button && !isPanelOpen(button)) openPanel(button);
    var message = document.querySelector("[data-loyalty-redemption-message]");
    if (message && typeof message.focus === "function") {
      message.setAttribute("tabindex", "-1");
      message.focus();
    }
  }

  function setButtonBusy(button, busy) {
    if (!button) return;
    button.disabled = Boolean(busy);
    if (busy) button.setAttribute("aria-busy", "true");
    else button.removeAttribute("aria-busy");
  }

  function updateCartChangedDetail(source) {
    return { source: source, refreshLoyalty: false, refreshSections: false };
  }

  function notifyCartChanged(source) {
    document.dispatchEvent(
      new CustomEvent("ss:cart:promotion:refresh", {
        detail: updateCartChangedDetail(source),
      }),
    );
  }

  function firstError(payload) {
    var errors =
      payload && Array.isArray(payload.userErrors) ? payload.userErrors : [];
    var first = errors.find(function (error) {
      return error && error.message;
    });
    return first ? String(first.message) : "";
  }

  function errorMessage(error) {
    return error && error.message
      ? String(error.message)
      : state.labels.unavailable;
  }

  function uniqueStrings(values) {
    var seen = Object.create(null);
    return (values || [])
      .map(function (value) {
        return String(value || "").trim();
      })
      .filter(function (value) {
        var key = value.toLowerCase();
        if (!value || seen[key]) return false;
        seen[key] = true;
        return true;
      });
  }

  function isLoyaltyCode(code) {
    return LOYALTY_CODE_PATTERN.test(String(code || "").trim());
  }

  function sameCode(left, right) {
    return (
      String(left || "")
        .trim()
        .toLowerCase() ===
      String(right || "")
        .trim()
        .toLowerCase()
    );
  }

  function normalizePath(path) {
    var value = String(path || "/apps/silksilky-app").replace(/\/+$/, "");
    return value || "/apps/silksilky-app";
  }

  function storefrontPath(path) {
    var root =
      window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root
        : "/";
    root = String(root || "/");
    if (root.charAt(root.length - 1) !== "/") root += "/";
    return root + String(path || "").replace(/^\/+/, "");
  }

  function normalizeCurrencyCode(value) {
    var code = String(value || "")
      .trim()
      .toUpperCase();
    return /^[A-Z]{3}$/.test(code) ? code : "";
  }

  function floorToIncrement(value, increment) {
    return Math.floor(Math.max(0, Number(value) || 0) / increment) * increment;
  }

  function roundCurrencyAmount(value) {
    return Math.round(Math.max(0, Number(value) || 0) * 100) / 100;
  }

  function readInteger(value) {
    var number = Number(value);
    return Number.isFinite(number) ? Math.floor(number) : 0;
  }

  function formatNumber(value) {
    try {
      return new Intl.NumberFormat(
        document.documentElement.lang || undefined,
      ).format(readInteger(value));
    } catch (_error) {
      return String(readInteger(value));
    }
  }

  function formatMoney(cents) {
    var value = Math.max(0, readInteger(cents));
    if (window.Shopify && typeof window.Shopify.formatMoney === "function") {
      return window.Shopify.formatMoney(value, state.moneyFormat || undefined);
    }
    try {
      return new Intl.NumberFormat(document.documentElement.lang || undefined, {
        style: "currency",
        currency: state.currencyCode,
      }).format(value / 100);
    } catch (_error) {
      return (value / 100).toFixed(2) + " " + state.currencyCode;
    }
  }

  function interpolate(template, values) {
    return Object.keys(values || {}).reduce(
      function (result, key) {
        return result.replace(
          new RegExp("{{\\s*" + key + "\\s*}}", "g"),
          values[key],
        );
      },
      String(template || ""),
    );
  }

  function escapeHtml(value) {
    var div = document.createElement("div");
    div.textContent = String(value || "");
    return div.innerHTML;
  }
})();
